import {Component, OnInit, ChangeDetectionStrategy} from "@angular/core";
import {NzMessageService} from "ng-zorro-antd/message";
import {lastValueFrom} from "rxjs";
import {
    FailedZonalTemplateListItemDto,
    PerFormaAPIService,
    ZonalTemplateListItemDto
} from "src/app/services/pfapi.service";

@Component({
    selector: "app-zonal-template-list",
    templateUrl: "./zonal-template-list.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ZonalTemplateListComponent implements OnInit {
    constructor(
        private readonly api: PerFormaAPIService,
        private readonly message: NzMessageService
    ) {}

    allTemplates: ZonalTemplateListItemDto[] = [];
    templates: ZonalTemplateListItemDto[] = [];
    loading = true;
    pageSize = 15;
    pageIndex = 1;
    pageSizeOptions = [10, 15, 20, 50];

    searchValue = "";

    failedTemplates: FailedZonalTemplateListItemDto[] = [];
    failedLoading = true;
    failedPageSize = 15;
    failedPageIndex = 1;

    async ngOnInit(): Promise<void> {
        await Promise.all([this.getData(), this.getFailedData()]);
    }

    async getData(): Promise<void> {
        this.loading = true;
        try {
            this.allTemplates = await lastValueFrom(this.api.getApiConfigureZonalTemplates());
            this.applyFilter();
        } catch (error) {
            this.message.error("Failed to load zonal templates");
            console.log(error);
        } finally {
            this.loading = false;
        }
    }

    async getFailedData(): Promise<void> {
        this.failedLoading = true;
        try {
            this.failedTemplates = await lastValueFrom(this.api.getApiConfigureZonalFailedTemplates());
        } catch (error) {
            this.message.error("Failed to load failed templates log");
            console.log(error);
        } finally {
            this.failedLoading = false;
        }
    }

    private applyFilter(): void {
        const search = this.searchValue.trim().toLowerCase();
        this.templates = search
            ? this.allTemplates.filter(t => (t.ZonalTemplateName ?? "").toLowerCase().includes(search))
            : this.allTemplates;
    }

    onSearch(): void {
        this.pageIndex = 1;
        this.applyFilter();
    }

    clearSearch(): void {
        this.searchValue = "";
        this.pageIndex = 1;
        this.applyFilter();
    }
}
